import { useState } from 'react';

import isFireTvUserAgent from 'isFireTvUserAgent';

const useIsFireTv = () => {
  const [isFireTv] = useState<boolean>(isFireTvUserAgent);

  return isFireTv;
};

export default useIsFireTv;
